import styled from "styled-components";

export const SystemEquipBoard = styled.div`
  position: relative;
  width: 812px;
  height: 448px;
  flex-shrink: 0;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const SystemEquipStatusList = styled.ul`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
`;
